import * as React from 'react';
import * as ToastPrimitives from '@radix-ui/react-toast';
import { Cross2Icon } from '@radix-ui/react-icons';
import { Flex, Text, Button } from '@radix-ui/themes';

interface ToastProps {
  id: string;
  title: string;
  description?: string;
  variant?: 'default' | 'destructive' | 'success';
  onDismiss: (id: string) => void;
}

const Toast = React.forwardRef<
  React.ElementRef<typeof ToastPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof ToastPrimitives.Root> & ToastProps
>(
  (
    { id, title, description, variant = 'default', onDismiss, ...props },
    ref,
  ) => {
    const getVariantStyles = () => {
      switch (variant) {
        case 'destructive':
          return {
            backgroundColor: '#fef2f2',
            border: '1px solid #fecaca',
            color: '#991b1b',
          };
        case 'success':
          return {
            backgroundColor: '#f0fdf4',
            border: '1px solid #bbf7d0',
            color: '#166534',
          };
        default:
          return {
            backgroundColor: '#f9fafb',
            border: '1px solid #e5e7eb',
            color: '#374151',
          };
      }
    };

    return (
      <ToastPrimitives.Root
        ref={ref}
        style={{
          ...getVariantStyles(),
          borderRadius: '8px',
          padding: '16px',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
          width: '300px',
          listStyleType: 'none',
        }}
        {...props}
      >
        <Flex justify="between" align="start" gap="3">
          <Flex direction="column" gap="1" style={{ flex: 1 }}>
            <Text size="2" weight="bold">
              {title}
            </Text>
            {description && (
              <Text size="1" style={{ opacity: 0.9 }}>
                {description}
              </Text>
            )}
          </Flex>
          <Button
            variant="ghost"
            size="1"
            onClick={() => onDismiss(id)}
            style={{ padding: 0, minWidth: 'auto' }}
          >
            <Cross2Icon width={12} height={12} />
          </Button>
        </Flex>
      </ToastPrimitives.Root>
    );
  },
);

Toast.displayName = ToastPrimitives.Root.displayName;

export default Toast;
